import React, { Component } from 'react';
import '../../css//agenttoolbar/agentmenu.css';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import SignalRService from '../../controllers/SignalRService';
import ChangePassword from '../user/changePassword';
import ChangeEmailPassword from '../user/changeEmailPassword';
import Channels from '../user/channels';
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import themes from "devextreme/ui/themes";
import SessionCosedNotification from '../user/sessionClosedNotification';
import { notify } from '../utils/utils';

class AgentMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showChangePassword: false,
            showChangeEmailPassword: false,
            showChannels: false,
            showSessionClosedModal: false,
            sessionClosedMessage: "",
            theme: localStorage.getItem("faTheme"),
            lastPause: new Date(1970, 1, 1, 0, 0, 0)
        }

        this.logout = this.logout.bind(this);
        this.toggleChangePasswordModal = this.toggleChangePasswordModal.bind(this);
        this.passwordExpiredEvent = this.passwordExpiredEvent.bind(this);
        this.toggleChangeEmailPasswordModal = this.toggleChangeEmailPasswordModal.bind(this);
        this.toggleChannels = this.toggleChannels.bind(this);
        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.setSessionClosedMessage = this.setSessionClosedMessage.bind(this);
        this.acdEvent = this.acdEvent.bind(this);

        SignalRService.registerPasswordExpiredEvent(this.passwordExpiredEvent);
        SignalRService.registerACDEvent(this.acdEvent);

    }

    componentDidMount() {

        document.addEventListener("mousedown", this.handleClickOutside);

        if (this.props.changePassword) {
            this.toggleChangePasswordModal();
        }

    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside(e) {
        if (this.props.showSettings && this.wrapperRef && !this.wrapperRef.current.contains(e.target) && !this.props.togglerRef.current.contains(e.target)) {
            this.props.toggleSettings();
        }
    }

    toggleChangePasswordModal = e => {

        if (e)
            e.preventDefault();

        this.setState({ showChangePassword: !this.state.showChangePassword });
        this.props.toggleSettings(false);
    }

    toggleChangeEmailPasswordModal = e => {

        if (e)
            e.preventDefault();

        this.setState({ showChangeEmailPassword: !this.state.showChangeEmailPassword });
        this.props.toggleSettings(false);
    }

    passwordExpiredEvent = e => {
        this.setState({ showChangePassword: true });
    }

    toggleChannels = e => {
        if (e)
            e.preventDefault();
        this.setState({ showChannels: !this.state.showChannels });
        this.props.toggleSettings(false);
    }


    logout(e) {
        e.preventDefault();
        SignalRService.disassociateMessage({ Extension: this.props.extension, UserId: this.props.userId }, x => { });
        localStorage.removeItem("fc-logged");
        window.location.reload();
    };

    changeTheme = e => {
        if (e)
            e.preventDefault();
        let theme = this.state.theme === "light" ? "dark" : "light";
        localStorage.setItem("faTheme", theme);
        this.setState({
            theme: theme
        });

        let html = document.getElementsByTagName("html")[0];
        html.setAttribute("data-theme", theme);
        themes.current(`generic.${theme}.compact`);

        let themeChanged = {
            Method: "ThemeChanged",
            Theme: theme
        };
        Array.from(document.getElementsByTagName("iframe")).forEach(x => {
            x.contentWindow.postMessage(themeChanged, '*');
        });
    }

    setSessionClosedMessage = (message) => {
        this.setState({ sessionClosedMessage: message, showSessionClosedModal: true });
        SignalRService.disconnect();
        localStorage.removeItem("fc-logged");
    }

    toggleSessionClosedModal = e => {
        if (e)
            e.preventDefault();
        this.setState({ showSessionClosedModal: !this.state.showSessionClosedModal });

        window.location.reload();
    }
    acdEvent = data => {

        if (data !== null && data.association !== null
            && (localStorage.getItem("faRCUser") === null || (localStorage.getItem("faRCUser") !== null && (localStorage.getItem("faRCUser").trim() === "")))) {

            SignalRService.getMailCredentials({ userId: data.association.userId, extension: data.association.shortExtension }, (error) => { });

        }

        if (data !== null && data.association !== null && data.association.message !== null && data.association.message.trim() !== "") {
            //! waiting for changes
            this.setSessionClosedMessage(data.association.message);
        }

        if (data !== null && data.acdStatus === "PAUSE") {

            var diff = (new Date() - this.state.lastPause) / 1000;

            if (diff > 5) {
                let body = "";

                if (data.pause && data.pause.description) {
                    body = data.pause.description;
                }

                notify("Fidelity Agent: " + this.props.t("pause"), body, `${window.location.origin}${window.location.pathname}/favicon.ico`, "pause");
                this.setState({
                    lastPause: new Date()
                });
            }

        }
    }
    render() {
        return (
            <>
                <div ref={this.wrapperRef} className={"menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color py-4 fs-6 w-275px " + (this.props.showSettings ? "show" : "")} >

                    <div className="menu-item px-3">
                        <div className="menu-content d-flex align-items-center px-3">

                            <div className="symbol symbol-50px me-5">
                                {
                                    (!this.props.photo) &&
                                    <div className='user-img text-primary bg-light-primary'>{this.props.initials}</div>
                                }

                                {
                                    (this.props.photo) &&
                                    <img src={`//${this.props.photo}`} alt="user" />
                                }
                            </div>
                            <div className="d-flex flex-column">
                                <div className="d-flex align-items-center fs-5">{this.props.name}</div>
                                <div className="text-muted fs-7">{this.props.shortExtension}</div>
                            </div>

                        </div>
                    </div>
                    <div className="separator my-2"></div>
                    <div className="menu-item px-5">
                        {
                            (this.state.theme === "light") &&
                            <a href='/' onClick={this.changeTheme} className="menu-link px-5">
                                <FontAwesomeIcon size='lg' icon={duotone("moon-stars")} />
                                <span className="px-2">{this.props.t("darkmode")}</span>
                            </a>
                        }
                        {
                            (this.state.theme === "dark") &&
                            <a href='/' onClick={this.changeTheme} className="menu-link px-5">
                                <FontAwesomeIcon size='lg' icon={duotone("sun")} />
                                <span className="px-2">{this.props.t("lightmode")}</span>
                            </a>
                        }
                    </div>
                    <div className="separator my-2"></div>
                    <div className="menu-item px-5">
                        <a href='/' onClick={this.toggleChannels} className="menu-link px-5">{this.props.t("channels")}</a>
                    </div>
                    <div className="separator my-2"></div>
                    <div className="menu-item px-5">
                        <a href='/' onClick={this.toggleChangePasswordModal} className="menu-link px-5">{this.props.t("changepassword")}</a>
                    </div>
                    <div className="menu-item px-5">
                        <a href='/' onClick={this.toggleChangeEmailPasswordModal} className="menu-link px-5">{this.props.t("changepasswordemail")}</a>
                    </div>
                    <div className="separator my-2"></div>
                    <div className="menu-item px-5">
                        <a href='/' onClick={this.logout} className="menu-link px-5">{this.props.t("logout")}</a>
                    </div>

                </div>
                <ChangePassword show={this.state.showChangePassword} toggleModal={this.toggleChangePasswordModal} userId={this.props.userId} extension={this.props.extension}></ChangePassword>
                <ChangeEmailPassword show={this.state.showChangeEmailPassword} toggleModal={this.toggleChangeEmailPasswordModal} userId={this.props.userId} extension={this.props.extension}></ChangeEmailPassword>
                <Channels show={this.state.showChannels} toggleModal={this.toggleChannels} userId={this.props.userId} extension={this.props.extension}></Channels>
                <SessionCosedNotification show={this.state.showSessionClosedModal} toggleModal={this.toggleSessionClosedModal} message={this.state.sessionClosedMessage} ></SessionCosedNotification>
            </>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        name: state.agent.name,
        status: state.agent.status,
        shortExtension: state.agent.shortExtension,
        photo: state.agent.photo,
        initials: state.agent.initials,
        duple: state.agent.duple,
        extension: state.agent.extension,
        userId: state.agent.userId,
        changePassword: state.parameters.changePassword
    };
};

export default compose(connect(mapStateToProps), withTranslation())(AgentMenu);